module.exports = __webpack_public_path__ + "img/20200514_142408.8177dc76.jpg";